import { FC } from 'react';
import Content from './Content';
import { BrowserView, MobileView } from 'react-device-detect';

const BookingView: FC = () => {
    return (
        <>
            <BrowserView>
                <Content />
            </BrowserView>
            <MobileView>
                <Content />
                {/*<Message>Varauskartta ei toimi mobiilissa, sry.. (nettisivuvelho hakusessa)</Message>*/}
            </MobileView>
        </>
    );
};

export default BookingView;
